import { Service } from '~publish/legacy/constants/services/ServiceDefinitions'
import type { ChannelOption } from '~publish/pages/Community/components/EmptyStates/ConnectSupportedChannelsCard'

/**
 * The channels the mentions empty state advertises, in display order, and which
 * of them are still on the roadmap. Purely presentational: whether a user sees
 * that empty state at all is decided by live per-channel support from the
 * configuration endpoint (`hasSupportedMentionsChannel`), not by these lists.
 *
 * When mentions ship for a channel, drop it from
 * {@link MENTIONS_COMING_SOON_SERVICES}; when a new channel joins the roadmap,
 * add it to both.
 */
export const MENTIONS_CHANNEL_OPTIONS: ChannelOption[] = [
  { service: Service.Twitter, label: 'X (Twitter)' },
  { service: Service.Instagram, label: 'Instagram' },
  // Mentions cover LinkedIn profiles only; a plain "LinkedIn" label would
  // imply pages are covered too.
  { service: Service.Linkedin, label: 'LinkedIn Profiles' },
]

export const MENTIONS_COMING_SOON_SERVICES: readonly Service[] = [
  Service.Instagram,
  Service.Linkedin,
]
